import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { enableRestrictedAssetAccess } from '@api/assetAccess';

import { IId } from '@interfaces/common/common';
import { IOrganizationId } from '@interfaces/common/defaultDTO';

import { EUserRoles } from '@enums/common';

import {
	ASSET_ACCESS,
	ASSET_ACCESS_RESTRICTED,
	ASSET_ACCESS_RESTRICTED_ENABLE,
} from '@constants/queryKeys';

interface IUseMutateEnableAssetAccessReturned {
	enableAssetAccess: UseMutateFunction<any, any, IId & Partial<IOrganizationId>, any>;
	isLoadingEnableAssetAccess: boolean;
}

export const useMutateEnableAssetAccess = (): IUseMutateEnableAssetAccessReturned => {
	const queryClient = useQueryClient();

	const {
		mutate,
		isLoading,
	} = useMutation<IId & Partial<IOrganizationId>>({
		mutationKey: [ASSET_ACCESS_RESTRICTED_ENABLE],
		mutationFn: enableRestrictedAssetAccess,
		allowedRoles: [EUserRoles.platformOwnerAdministrator],
		onSuccess: () => {
			return [
				queryClient.invalidateQueries([ASSET_ACCESS_RESTRICTED]),
				queryClient.invalidateQueries([ASSET_ACCESS]),
			];
		},
	});

	return {
		enableAssetAccess: mutate,
		isLoadingEnableAssetAccess: isLoading,
	};
};
